import React, { useEffect, useState } from 'react';
import { giftCard } from '../../Image/Index';
import { useNavigate } from 'react-router-dom';
import {
	getSelectGiftCard,
	getAllGiftcard,
	getGiftcards,
} from '../../actions/auth';
import Header from '../layout/Header';
import { Modal, Button } from 'react-bootstrap';
import parse from 'html-react-parser';
import { encrypt } from '../../utils/encodingdecoding';
import { useDispatch } from 'react-redux';
import { VENDOR_LABEL_MAP } from '../../utils/helper';
import { handleGiftCardsAndProductDetails } from '../store/reducers/giftcardsSlice';

const ResellerHome = () => {
	const navigate = useNavigate();
	const [loader, setLoader] = useState(true);
	const [giftCards, setGiftCards] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [filteredData, setFilteredData] = useState('');
	const [show, setShow] = useState(false);
	const [modelData, setModelData] = useState([]);
	const dispatch = useDispatch();

	const handleClose = () => setShow(false);

	const handleShow = async (ele) => {
		setModelData(ele);
		setShow(true);
	};

	useEffect(() => {
		const fetch = async () => {
			// const all = await getAllGiftcard();
			const res = await dispatch(getGiftcards({ status: 1 }));
			// const response = await getSelectGiftCard(
			// 	localStorage.getItem('merchantcode'),
			// );

			// let temp = [];
			// response?.data?.filter((res) => {
			// 	const { gc_vendor } = res;
			// 	let tempVendor = gc_vendor.split(',');
			// 	tempVendor.filter((ven) => {
			// 		all?.data?.filter((detail) => {
			// 			const { image, ...rest } = detail;
			// 			if (ven === detail.default_vendor_code) {
			// 				res.giftcard_code.forEach((giftcard) => {
			// 					if (giftcard.id === detail.id) {
			// 						temp.push({
			// 							...rest,
			// 							image: image ? image : giftCard,
			// 							discount: giftcard.discount,
			// 							merchantName:
			// 								giftcard.vendor_code ===
			// 								'VENVA6DCERYE'
			// 									? 'qc'
			// 									: 'razor-pay',
			// 							id: giftcard.id,
			// 						});
			// 						return temp;
			// 					}
			// 				});
			// 			}
			// 		});
			// 	});
			// });
			setGiftCards(
				res?.data
					.filter((item) => item?.client_details?.status)
					.map((item) => ({
						...item,
						image: item.image ? item.image : giftCard,
						merchantName:
							VENDOR_LABEL_MAP[item.default_vendor_code],
					})),
			);
			setLoader(false);
		};
		fetch();
		// localStorage.setItem('isMultipleSelection', encrypt('false'));	
		localStorage.setItem('isMultipleSelection', encrypt('true'));
	}, []);
	const handleChange = (e) => {
		const temp = e.target.value.toLowerCase();
		setSearchTerm(temp);
		if (e.target.value) {
			const tempData = giftCards.filter((item) =>
				item.title.toLowerCase().includes(temp),
			);
			setFilteredData(tempData);
		} else {
			setFilteredData('');
		}
	};

	const handleBuy = (detail) => {
		navigate('/reseller-details', { state: detail });
		// dispatch(handleGiftCardsAndProductDetails(detail));
		// navigate(`/reseller-details/${detail?.code}`);
	};

	const showCards = (data) => {
		return data.map((ele, index) => (
			<div
				className='cardbox'
				key={index}>
				<div className='cardinnerbox'>
					<div className='cardibox'>
						<button>
							{ele?.client_details?.discount && (
								<span className='disount_label'>
									{ele?.client_details?.discount}% off
								</span>
							)}
							<div className='cardiboxed'>
								<img
									src={ele?.image}
									alt={ele.title}
									onClick={() => handleShow(ele)}
									onerror='https://dummyimage.com/600x400/000/fff'
								/>
							</div>
						</button>
					</div>
					<div className='cardstrip'></div>
					<div className='cardcbox'>
						<h4>{ele.title}</h4>
						<button onClick={() => handleBuy(ele)}> Buy Now</button>
					</div>
				</div>
			</div>
		));
	};

	return (
		<>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='reseller_home'>
				<Header name='Gift Cards' />

				<div className='reseller_home__body'>
					<div className='reseller_home__body__filter'>
						<div className='reseller_home__body__filter__left'></div>
						<div className='reseller_home__body__filter__right'>
							<input
								type='text'
								value={searchTerm}
								placeholder='Search Gift Cards'
								onChange={handleChange}
							/>
						</div>
					</div>
					<div className='reseller_home__body__cardsBox'>
						<div className='cardsrow'>
							{loader ? (
								''
							) : Array.isArray(filteredData) ? (
								filteredData?.length ? (
									showCards(filteredData)
								) : (
									<h6 className='text-center'>
										No Record Found
									</h6>
								)
							) : giftCards?.length > 0 ? (
								showCards(giftCards)
							) : (
								<h6 className='text-center'>No Record Found</h6>
							)}
						</div>
					</div>
				</div>
			</div>

			<div>
				<Modal
					show={show}
					onHide={handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>{modelData.title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className='big_card_row_main'>
							<div className='big_card_row'>
								<div className='big_card_boxL'>
									<img
										src={modelData.image}
										alt='Gift card'
										onerror='https://dummyimage.com/600x400/000/fff'
									/>
								</div>
								<div className='big_card_boxR'>
									<h3>{modelData.title}</h3>
								</div>
							</div>
							<div className='big_card_row_2'>
								<p className='scrollable'>
									{modelData?.tnc && parse(modelData?.tnc)}
								</p>
								{/* <div className="big_card_row_details">
                                    <div className="big_card_row_details_L">
                                        <h4>Price</h4>
                                        <ul>
                                            {modelData?.vendors &&
                                                modelData?.vendors[0]?.denominations?.map((item) => (
                                                    <>
                                                        <li>${item.fix_value}</li>
                                                    </>
                                                ))}
                                        </ul>
                                    </div>
                                    <div className="big_card_row_details_R">
                                        <h4>Discount</h4>
                                        <ul>
                                            <li>{modelData.discount ? `${modelData.discount} %` : "0"}</li>
                                        </ul>
                                    </div>
                                </div> */}
								<div className='big_card_row_3'>
									<button
										onClick={() => handleBuy(modelData)}>
										Buy Now
									</button>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		</>
	);
};

export default ResellerHome;
